import { del, get, post, put } from '@/utils/request'
import { withTwoFactor, type TwoFactorOptions } from '@/utils/twoFactor'
import type {
  AppDomainItem,
  AppDomainListParams,
  AppDomainOptionsResponse,
  AppDomainPayload,
} from '@/types/appDomain'
import type { PaginatedData } from '@/types/api'

export function getAppDomainList(
  params?: AppDomainListParams
): Promise<PaginatedData<AppDomainItem>> {
  return get<PaginatedData<AppDomainItem>>('/admin/v1/app-domains', params)
}

export function createAppDomain(
  data: AppDomainPayload,
  options?: TwoFactorOptions
): Promise<AppDomainItem> {
  return post<AppDomainItem>('/admin/v1/app-domains', data, withTwoFactor(options))
}

export function updateAppDomain(
  id: string,
  data: AppDomainPayload,
  options?: TwoFactorOptions
): Promise<AppDomainItem> {
  return put<AppDomainItem>(`/admin/v1/app-domains/${id}`, data, withTwoFactor(options))
}

export function deleteAppDomain(id: string, options?: TwoFactorOptions): Promise<void> {
  return del<void>(`/admin/v1/app-domains/${id}`, undefined, withTwoFactor(options))
}

/** 右上角域名切换候选项：登录即可调用，绑定了域名的管理员只返回其绑定域名。 */
export function getAppDomainOptions(): Promise<AppDomainOptionsResponse> {
  return get<AppDomainOptionsResponse>('/admin/v1/app-domains/options')
}
